module.exports = __webpack_public_path__ + "distribution/img/new-code.409f5c82.png";